export default __webpack_public_path__ + "static/media/paramount_plus.e6c9c3e3.png";